import Vue from 'vue'
import { AxiosError, AxiosResponse } from 'axios'

const opportunityRelations = [
  'step', 'category', 'funnel', 'teamUser', 'customer', 'customer_child', 'contact', 'customFields', 'linked_documents',
  'customer.datas', 'customer_child.datas', 'loss_reason'
]

const needFetchOpportunity = (opportunity: KwixeoOpportunities.Opportunity): boolean => {
  return !opportunityRelations.every(relation => relation in opportunity)
}

const fetchOpportunity = async (id: number|string): Promise<KwixeoOpportunities.Opportunity> => {
  return await Vue.prototype.$kwOpportunities.axios.get('/opportunity/' + id, {
      params: {
        include: opportunityRelations.join(',')
      }
    })
    .then((response: AxiosResponse) => {
      return response.data
    })
    .catch((error: AxiosError) => {
      throw new Error((error.response as AxiosResponse)?.data)
    })
}

export {
  opportunityRelations, needFetchOpportunity, fetchOpportunity
}
